import NewImage from "assets/images/new-imag.png";
import CircularProgress from "component/misc/CircularProgress.jsx";
import useBreakpoint from "utils/useBreakPoint.js";
import { useNavigate } from "react-router-dom";
import { timeAgo } from "utils/timeAgo.js";
import { useTranslation } from "react-i18next";
import { translateSectorLabel } from "utils/sectorLabel";

const ReportCard = (props) => {
    const { t, i18n } = useTranslation();
    const {
        value,
        title,
        summary,
        _id,
        reportType,
        progress = 70,
        image_url,
        sectors,
        created_at,
        reading_time_minutes,
    } = props;
    const parsedReadingTime = Number(reading_time_minutes);
    const readingMinutes = Number.isFinite(parsedReadingTime) && parsedReadingTime > 0
        ? Math.round(parsedReadingTime)
        : 1;
    const sectorLabel = (sector) => {
        if (typeof sector === "string") return sector;
        if (sector && typeof sector === "object") return sector.name || sector.slug || "";
        return "";
    };

    const navigate = useNavigate();

    const handleClick = () => {
        if (_id) {
            const target =
                reportType === "custom"
                    ? `/reports/view/${_id}?type=custom`
                    : `/reports/view/${_id}`;
            navigate(target);
        }
    };


    return (
        <div
            className="reportCard overflow-hidden rounded-4"
            style={{ cursor: _id ? "pointer" : "default" }}
            onClick={handleClick}
        >
            <div className="row g-0">
                {/* Left image */}
                <div className="col-4 news_image_box">
                    <img
                        src={image_url || NewImage}
                        alt={title || t("reports.card.imageAlt")}
                        className="w-100 h-100 object-fit-cover"
                        onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = NewImage;
                        }}
                    />
                </div>

                {/* Right content */}
                <div className="col-8 card_detail_box text-white d-flex flex-column justify-content-between">
                    <div>
                        <h5 className="fw-light news_card_title">
                            {title || t("reports.card.fallbackTitle")}
                        </h5>
                        <p className="text-white fw-light reportCard_description">
                            {summary ||
                                t("reports.card.fallbackSummary")}
                        </p>
                    </div>

                    <div className="news_detail d-flex align-items-center justify-content-between gap-2 flex-wrap">
                        <div className="category_wrap d-flex gap-1 align-items-center small">
                            {sectors &&
                                sectors.slice(0, 2).map((sector, idx) => (
                                    <span key={idx} className="category text-white rounded-4">
                                        {translateSectorLabel(sectorLabel(sector), i18n.resolvedLanguage || i18n.language)}
                                    </span>
                                ))}
                        </div>
                        <div className="category_wrap d-flex align-items-center gap-3 small">
                            <span className="post_time">{readingMinutes} {t("reports.readTime.min")}</span>
                            <CircularProgress progress={progress} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportCard;
